import { api } from '../api';

export type ListViewMode = 'table' | 'tile';

/** Per-user interface choices the server remembers. Every key is optional. */
export interface UiPreferences {
  menuItemsViewMode?: ListViewMode;
}

export const uiPreferenceRequests = {
  get: () => api.get<UiPreferences>('/users/me/ui-preferences'),

  /** Merges the given keys into the stored preferences and returns them all. */
  update: (patch: Partial<UiPreferences>) =>
    // skipToast: a preference that fails to save is rolled back by the hook;
    // it is not worth an error toast.
    api.patch<UiPreferences>('/users/me/ui-preferences', patch, { skipToast: true }),
};
